<div class="app-container">
    @if (isDevelopment) {
        <div class="env-banner">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ environmentLabel }}</span>
        </div>
        <div class="env-watermark" aria-hidden="true">{{ environmentLabel }}</div>
    }
    <app-banner [banner]="banner"></app-banner>
    <div class="relative flex flex-1 min-h-0 overflow-hidden" [ngClass]="{ 'home-bg': isHome }">
        @if (userInfo$ | async) {
            <app-sidebar></app-sidebar>
        }
        <main
            class="main-content"
            [style.margin-left]="
                (userInfo$ | async) ? ((isVisibleSidebar$ | async) ? '27rem' : '3rem') : '0'
            "
        >
            <router-outlet></router-outlet>
            @if (userInfo$ | async) {
                <app-favorite-toggle></app-favorite-toggle>
            }
            <p-toast position="top-right" key="aed-duplicate" [baseZIndex]="6000" />
            <p-toast position="top-right" key="communication-table-toast" [baseZIndex]="6000" />
            <p-toast position="top-right" key="report-generation" [baseZIndex]="6000">
                <ng-template pTemplate="message" let-message>
                    <span
                        class="p-toast-message-icon"
                        [ngClass]="notificationService.getStickyToastIcon(message)"
                    ></span>
                    <div
                        class="p-toast-message-text"
                        [attr.data-p]="notificationService.getStickyToastSeverity(message)"
                    >
                        <div
                            class="p-toast-summary"
                            [attr.data-p]="notificationService.getStickyToastSeverity(message)"
                        >
                            {{ notificationService.getStickyToastSummary(message) }}
                        </div>
                        <div
                            class="p-toast-detail"
                            [attr.data-p]="notificationService.getStickyToastSeverity(message)"
                        >
                            {{ notificationService.getStickyToastDetail(message) }}
                        </div>
                    </div>
                </ng-template>
            </p-toast>
            <p-toast position="top-right" key="msc-export" [baseZIndex]="6000" />
            <p-toast position="bottom-right" [baseZIndex]="5000" />
            <p-toast position="bottom-right" key="access-denied" [baseZIndex]="5001">
                <ng-template pTemplate="message" let-message>
                    <span class="p-toast-message-icon pi pi-times-circle"></span>
                    <div class="p-toast-message-text">
                        <div class="p-toast-summary">{{ message.summary }}</div>
                        <div class="p-toast-detail">{{ message.detail }}</div>
                        <a
                            class="p-toast-detail access-request-link"
                            [href]="message.data.accessRequestUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Request SESAMM Tool access
                            <i
                                class="pi pi-external-link access-request-icon"
                                aria-hidden="true"
                            ></i>
                        </a>
                    </div>
                </ng-template>
            </p-toast>
            <p-confirmdialog [baseZIndex]="7000" acceptLabel="Yes" rejectLabel="No" />
            <p-confirmpopup
                [baseZIndex]="8000"
                acceptLabel="Yes"
                key="removeSignalPopup"
                rejectLabel="No"
            />
        </main>
    </div>
</div>
